import React from "react";
import PropTypes from "prop-types";

import propTypes from "../../../../../constants/propTypes";
import LocalGrid from "./../../../../ui/Grid/LocalGrid";
import { dateTypeBuilder } from "../../../../ui/Grid/utilComponents/dataTypeProviders";
import {
  actionIconsBuilder,
  approveTypeBuilder,
  filenameTypeBuilder,
} from "./dataTypeProviders";
import sortSubmittalFiles from "./sortSubmittalFiles";
import {
  Cell,
  HeadCell,
} from "../../../../ui/Grid/utilComponents/tableComponents";
import { LoaderContext } from "../../../../ui/Loader";

// Only the titled columns show a skeleton while loading: the approve and
// delete columns have no title, and their 150px header skeletons overflowed
// the panel's width and made it scroll
const isUntitled = ({ title }) => typeof title === "string" && !title.trim();

const withoutUntitledLoader = CellComponent => {
  const UntitledAwareCell = props =>
    isUntitled(props.column) ? (
      <LoaderContext.Provider value={{ loading: false }}>
        <CellComponent {...props} />
      </LoaderContext.Provider>
    ) : (
      <CellComponent {...props} />
    );
  UntitledAwareCell.propTypes = { column: PropTypes.shape({}) };
  return UntitledAwareCell;
};

const tableComponents = {
  GridWrapper: ({ children }) => children,
  CellComponent: withoutUntitledLoader(Cell),
  HeaderCellComponent: withoutUntitledLoader(HeadCell),
};

const Grid = ({
  gridId,
  specRequirement,
  onDelete,
  onApprove,
  loaderActive,
}) => {
  return (
    <LocalGrid
      gridId={gridId || "submittals-files"}
      rows={sortSubmittalFiles(specRequirement.submittalFiles)}
      columns={[
        { name: "file.filename", title: "Filename", bold: true },
        { name: "createdAt", title: "Date Uploaded" },
        { name: "approved", title: " " },
        { name: "actionIcons", title: " " },
      ]}
      tableComponents={tableComponents}
      dataTypeProviders={[
        dateTypeBuilder(["createdAt"]),
        actionIconsBuilder(onDelete),
        approveTypeBuilder(specRequirement, onApprove, !!loaderActive),
        filenameTypeBuilder(),
      ]}
    />
  );
};

Grid.propTypes = {
  specRequirement: propTypes.specRequirement,
  onDelete: PropTypes.func,
  onApprove: PropTypes.func,
  loaderActive: PropTypes.string,
  gridId: PropTypes.string,
};

export default Grid;
